interface GameSelectionReturn {
  toggleGameSelection: (gameId: string) => void
}

export const useGameSelection = (
  selectedGames: Set<string>,
  setSelectedGames: (games: Set<string>) => void
): GameSelectionReturn => {
  const toggleGameSelection = (gameId: string) => {
    console.log('toggleGameSelection called with:', gameId)
    console.log('current selectedGames:', selectedGames)
    const newSelection = new Set(selectedGames)
    if (newSelection.has(gameId)) {
      newSelection.delete(gameId)
    } else {
      newSelection.add(gameId)
    }
    setSelectedGames(newSelection)
  }

  return {
    toggleGameSelection,
  }
}
